<template>
  <div class="trustpilot">
    <div class="trustpilot__rating trustpilot-rating">
      <span class="trustpilot-rating__label"> {{ $t(trustscoreData.starLabel) }}</span>
      {{ totalScore }}
    </div>

    <i18n
      tag="a"
      path="trustpilot.reviews"
      href="https://www.trustpilot.com/review/universkin.com"
      target="_blank"
      class="trustpilot__reviews-link"
      >{{ reviewsNumber }}
    </i18n>

    <div class="trustpilot__stars-block trustpilot-stars-block">
      <div
        class="trustpilot-stars-block__progress"
        :style="{ width: trustscoreData.progressWidth }"
      ></div>
      <div class="trustpilot-stars-block__stars-list stars-list">
        <span class="stars-list__item"></span>
        <span class="stars-list__item"></span>
        <span class="stars-list__item"></span>
        <span class="stars-list__item"></span>
        <span class="stars-list__item"></span>
      </div>
    </div>
    <div class="trustpilot__source-logo"></div>
  </div>
</template>

<script>
const getTrustScoreDataConfig = rating => {
  switch (true) {
    case rating >= 3.3 && rating <= 3.7: {
      return { progressWidth: '70%', starLabel: 'trustpilot.reviewScore.average' };
    }
    case rating >= 3.8 && rating <= 4.2: {
      return { progressWidth: '80%', starLabel: 'trustpilot.reviewScore.great' };
    }
    case rating >= 4.3 && rating <= 4.7: {
      return { progressWidth: '90%', starLabel: 'trustpilot.reviewScore.excellent' };
    }
    case rating >= 4.8 && rating <= 5: {
      return { progressWidth: '100%', starLabel: 'trustpilot.reviewScore.excellent' };
    }
    default: {
      return { progressWidth: '100%', starLabel: 'trustpilot.reviewScore.excellent' };
    }
  }
};

export default {
  name: 'TrustBox',
  props: {
    totalScore: {
      type: Number,
      default: 0
    },
    reviewsNumber: {
      type: Number,
      default: 0
    }
  },
  computed: {
    trustscoreData() {
      return getTrustScoreDataConfig(this.totalScore);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';

.trustpilot {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  align-items: center;
  color: var(--u-color-black-5);
  font-size: 14px;
  line-height: 20px;

  &__rating {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }

  &__reviews-link {
    margin-inline-start: 2px;
    color: var(--u-color-grey-900);
  }

  &__stars-block {
    position: relative;
    width: 150px;
    height: 28px;
    background-color: var(--u-color-grey-200);
  }

  &__source-logo {
    width: 100px;
    height: 28px;
    background-image: url(~@/assets/images/trustpilot-reviews/tp-logo.svg);
    background-repeat: no-repeat;
    background-size: contain;
  }
}

.trustpilot-stars-block {
  &__progress,
  &__stars-list {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &__progress {
    background-color: var(--u-color-grey-500);
  }
}

.trustpilot-rating {
  &__label:after {
    content: '•';
    border-radius: 50%;
    margin: 0 6px 0 8px;
  }
}

.stars-list {
  &__item {
    display: inline-block;
    width: 30px;
    height: 28px;
    border-right: 2px solid $white-color;
    background-image: url(~@/assets/images/trustpilot-reviews/star.svg);
    background-repeat: no-repeat;
    background-position: center;
  }

  &__item:last-child {
    border-right: none;
  }
}

@media (min-width: 960px) {
  .trustpilot {
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 16px;
  }
}
</style>
